import { alpha, Box, Button, Card, CardContent, CardHeader, IconButton, InputBase, Menu, MenuItem, Pagination, Paper, Stack, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { ChangeEventHandler, useCallback, useEffect, useState ,KeyboardEvent } from "react";
import { useNavigate } from "react-router-dom";
import { T_Inquery } from "../../common/model/InqueryModel";
import { useProgress } from "../../contexts/ProgressContextProvider";
import { T_Page } from "../../common/model/apiModel";
import apis from "../../common/apis";
import { T_Param } from "../../common/model/paramModle";
import { T_Error } from "../../common/model/errorModel";
import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import SearchIcon from '@mui/icons-material/Search';
import { keyboard } from "@testing-library/user-event/dist/keyboard";
import { Search, SearchIconWrapper, StyledInputBase, StyledTableCell } from "../../common/style/styles";

export default function ErrorList(){
    const nav = useNavigate();

    
    const pagesize = 10;
    const [page,setPage] = useState(1);
    const [list,setList] =  useState<T_Error[] | null>(null);
    const {showProgress,setShowProgress} = useProgress();
    const [pageInfo,setPageInfo] = useState<T_Page>()
   const {alert,setAlert} = useAlert();
    const [skeyword,setSkeyword]=useState("");

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
      };

     const getList = useCallback(async () => {
        try {
          setShowProgress(true);
          const result = await apis.error.errorList(
            {
              page:Number(page),
              pagesize:pagesize,
              skeyword:skeyword,
            }
          );
          console.log("resut:",result)
            if(result.code=="1"){
            
                setList(result.data.list);
                setPageInfo(result.data);
                setShowProgress(false);
    
            }else{
                 
              setShowProgress(false);
            }
    
       
    
        } catch (err: any) {
          setShowProgress(false);
        }
      }, [page,skeyword]);

      useEffect(() => {
          getList();
      }, [page]);
    
      

    

      
     const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
      const [menuRow, setMenuRow] = useState<number | null>(null)
      const open = Boolean(anchorEl);
      const handleClick = (e: React.MouseEvent<HTMLElement>, idx: number) => {
        setAnchorEl(e.currentTarget)
        setMenuRow(idx)
      }   
      const handleClose = () => {
          setAnchorEl(null);
          setMenuRow(null);
        }; 
   

        const handleDataDel = (data:T_Error) => {
          setAlert({...alert,title:"확인",msg:"정말로 삭제 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{
                    const result = await apis.error.errorDelete(data);
                    console.log("result:",result);
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"삭제가 완료되었습니다."});
                        getList();
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"삭제중 오류가 발생했습니다.."})
                    }
           
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }]
          });
        }
   


 function onKeyDown(e: KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
    if (e.key === 'Enter') {
      e.preventDefault(); // form 리프레시 방지
        getList()
    }
  }
    return(
        <Box sx={{ width: '100%' }}>
      <Card sx={{width:'100%'}} >
        <CardHeader sx={{pr:5,pb:0,mb:0}} title="에러관리"  action={
                  <Stack  direction="row"
                justifyContent="space-between"  // ← 여기만 바꿔주세요
                spacing={2}                     // 아이템 사이 약간의 간격
                sx={{ pt: 5, width: '100%' }}   // 전체 너비 확보
               >
                     <Search>
                      <SearchIconWrapper onClick={() => setPage(1)}>
                        <SearchIcon />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Search…"
                        inputProps={{ 'aria-label': 'search' }}
                        value={skeyword}
                        onChange={(e) => {
                          setSkeyword(e.target.value);
                        }
                      }
                        onKeyDown={onKeyDown}
                      />
                    </Search>
                            <Button variant="outlined" onClick={()=>{
                    nav("/error/insert")
                  }}>
                   등록
                  </Button>

                  </Stack>
                } />
        <CardContent>
        <TableContainer component={Paper}>
      <Table  aria-label="simple table" sx={{width:'100%'}}>
        <TableHead>
          <TableRow>
            <StyledTableCell  sx={{width:100,textAlign:'center'}}>에러코드</StyledTableCell>
            <StyledTableCell align="right" sx={{width:'20%',textAlign:'center'}} >오류내용</StyledTableCell>
            <StyledTableCell align="right"  sx={{width:'60%',textAlign:'center'}}>처리방법</StyledTableCell>
            <StyledTableCell align="right"  sx={{textAlign:'center'}}>비고</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {list && list.map((item,index) => (
            <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {item.errcode}
              </TableCell>
              <TableCell align="left">{item.title}</TableCell>
              <TableCell align="left">{item.content}</TableCell>
              <TableCell align="center">{ <>
                    <IconButton
                      aria-label="menu"
                      onClick={(e) => handleClick(e, index)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={menuRow === index}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleClose()
                          nav("/error/edit",{state:{item:item}})  
                        }}
                      >
                        수정
                      </MenuItem>
                      <MenuItem
                        onClick={async() => {
                          handleClose()
                          handleDataDel(item)
                        }}
                      >
                        삭제
                      </MenuItem>
                    </Menu>
                  </>}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
        <Stack   direction="row"
  justifyContent="flex-end"
  alignItems="center" sx={{pt:5,justifyContent:'center',alignContent:'center',justifyItems:'center',alignItems:'ceter'}}>
        <Pagination count={pageInfo?.pages} showFirstButton showLastButton  onChange={handleChange}/>
        </Stack>
        </CardContent>
      </Card>
      </Box>
    )
}